import * as React from "react";
import { BarChart, LineChart, PieChart } from "@mui/x-charts";

const GenericChart = ({ chartData }) => {
  const colorsList = [
    "#033666",
    "#00D1FF",
    "#0068A7",
    "#0092CA",
    "#00A7DC",
    "#03457B",
    "#01B2F5",
    "#0077B3",
    "#00B5E4",
    "#00C6F2",
    "#023E73",
    "#02A9F2",
    "#0083C2",
    "#00D9F5",
  ];
  const barChartColors = [
    "#274772",
    "#98AEB7",
    "#274772",
    "#002649",
    "#00D1FF",
    "#0068A7",
    "#0092CA",
  ];

  const formatYAxisTick = (value) => {
    // if (value >= 1000000) {
    //   return (value / 1000000).toFixed(1) + "M";
    // } else if (value >= 500000) {
    //   return "0.5M";
    // } else if (value >= 0) {
    //   return "0M";
    // } else {
    //   return value.toString();
    // }
    if (value >= 1000000) {
      return (value / 1000000).toFixed(1) + "M";
    } else if (value >= 1000) {
      return (value / 1000).toFixed(1) + "K";
    } else {
      return value.toString();
    }
  };
  const formatXAxisTick = (value, context) => {
    const pattern = /^\d{4}-\d{2}$/;

    if (pattern.test(value)) {
      return value;
    }
    if (context.location === "tick" && value) {
      return value
        .split("-")
        .map((word) => word.charAt(0))
        .join("");
    }

    return value;
  };

  const type = chartData.yAxis[0].type;
  if (type.toLowerCase() === "bar") {
    return (
      <>
        <BarChart
          legend={{ hidden: true }}
          series={chartData.yAxis.map((series, index) => ({
            type: "bar",
            data: series.data,
            label: series.lineLabel,
            // stack: chartData.yAxis.length > 1 ? true : false,

            color: barChartColors[index],
          }))}
          yAxis={[
            {
              scaleType: "linear",
              valueFormatter: formatYAxisTick,
              tickLabelStyle: {
                textAnchor: "end",
                fontSize: 12,
                fill: "#033666",
              },
              axisLine: {
                stroke: "#033666",
              },
            },
          ]}
          xAxis={[
            {
              data: chartData.xAxis[0].data,
              scaleType: "band",
              valueFormatter: formatXAxisTick,
              tickLabelStyle: {
                angle: -90,
                textAnchor: "end",
                fontSize: 12,
                fill: "#033666",
              },
              axisLine: {
                stroke: "#033666",
              },
            },
          ]}
          grid={{ vertical: true, horizontal: true }}
        />
      </>
    );
  } else if (type.toLowerCase() === "line" || type.toLowerCase() === "area") {
    return (
      <>
        <LineChart
          legend={{ hidden: true }}
          series={chartData.yAxis.map((series, index) => ({
            area: type.toLowerCase() === "line" ? true : false,
            showMark: type.toLowerCase() === "line" ? false : true,
            type: "line",
            data: series.data,
            label: series.lineLabel,

            color: colorsList[index],
          }))}
          yAxis={[
            {
              scaleType: "linear",
              valueFormatter: formatYAxisTick,
              tickLabelStyle: {
                textAnchor: "end",
                fontSize: 12,
                fill: "#033666",
              },
              axisLine: {
                stroke: "#033666",
              },
            },
          ]}
          xAxis={[
            {
              data: chartData.xAxis[0].data,
              scaleType: "band",
              valueFormatter: formatXAxisTick,
              tickLabelStyle: {
                angle: -90,
                textAnchor: "end",
                fontSize: 12,
                fill: "#033666", // change x-axis label color
              },
              axisLine: {
                stroke: "#033666", // change x-axis line color
              },
            },
          ]}
          grid={{ vertical: true, horizontal: true }}
        />
      </>
    );
  } else if (type.toLowerCase() === "pie") {
    let pieChartData = [];

    chartData.yAxis[0].data.forEach((ele, index) => {
      pieChartData.unshift({
        id: index,
        value: ele,
        label: chartData.xAxis[0].data[index],
        color: colorsList[index],
      });
    });
    const TOTAL = pieChartData
      .map((item) => item.value)
      .reduce((a, b) => a + b, 0);
    const getArcLabel = (params) => {
      const percent = params.value / TOTAL;
      return `${(percent * 100).toFixed(0)}%`;
    };

    return (
      <>
        <PieChart
          series={[
            {
              data: pieChartData,
              innerRadius: 40,
              outerRadius: 80,
              //arcLabel: getArcLabel,
              arcLabelProps: {
                style: {
                  fill: "#fff", // Set the color of the arc label to dark gray
                  fontSize: 12,
                },
              },
            },
          ]}
          legend={{ hidden: true }}
          margin={{ top: 20, bottom: 10, left: 200, right: 100 }}
        />
      </>
    );
  }
};

export default GenericChart;
